import 'leaflet/dist/leaflet.css'
import 'leaflet.fullscreen/Control.FullScreen.css'
import leafletFullscreen from 'leaflet.fullscreen'
import L from 'leaflet'
import leafletImage from 'leaflet-image'
import html2canvas from 'html2canvas'
import { risQScores } from './risq_score.js'
import { SocialScores } from './social_score.js'
import axios from 'axios'
import mergeImages from 'merge-images';
import leafletEasyprint from 'leaflet-easyprint'


const defaultCoords = [37.8, -86]
const defaultZoom = 4

export function getColor(val,mapMode) {
  if (mapMode == 'rscore') {
    return risQScores.getColor(val)
  } else {
    return SocialScores.getColor(val)
  }
}

export function featureColor(feature, mapMode, mapMetric) {
  if (mapMode == 'rscore') {
    return feature.properties.rscores.color(mapMetric)
  } else {
    return feature.properties.sscores.color(mapMetric)
  }
}

//this will be attached to tile elements
const options = function(id) {
  return {
    attribution: '© <a href="https://www.mapbox.com/about/maps/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> <strong><a href="https://www.mapbox.com/map-feedback/" target="_blank">Improve this map</a></strong>',
    tileSize: 512,
    maxZoom: 18,
    zoomOffset: -1,
    id: id,
    accessToken: 'pk.eyJ1IjoicnlhbmRvbGVuIiwiYSI6ImNrM2NhbmdyczBpYjYzbW50a3NpMXh4enEifQ.xklz5EEQg-7F5jVLCqOfIg',
    preferCanvas: true

  }
}
const mapboxUrl = 'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}'

export const lightLayer = L.tileLayer(mapboxUrl, options('mapbox/light-v10'))


export function initMap(element, defaultBaseMapIndex = 0) {
  const lightLayer = L.tileLayer(mapboxUrl, options('mapbox/light-v10'))
  const darkLayer = L.tileLayer(mapboxUrl, options('mapbox/dark-v10'))
  const satelliteLayer = L.tileLayer(mapboxUrl, options('mapbox/satellite-streets-v11'))
  const outdoorsLayer = L.tileLayer(mapboxUrl, options('mapbox/outdoors-v11'))
  const baseMaps = {
    Light: lightLayer,
    Dark: darkLayer,
    Satellite: satelliteLayer,
    Terrain: outdoorsLayer
  }

  const map = L.map(element, {

    minZoom: 3,
    maxZoom: 18,
    preferCanvas: true,
    fullscreenControl: true,
    fullscreenControlOptions: {
      position: 'topleft'
    },
    zoomControl: false,



  }).setView(defaultCoords, defaultZoom)
  const defaultLayer = baseMaps[Object.keys(baseMaps)[defaultBaseMapIndex]]
  defaultLayer.addTo(map)

  L.control.layers(baseMaps, null, {position: 'topleft'}).addTo(map)
  new L.Control.Zoom({ position: 'topleft' }).addTo(map);

  const wordmark = L.DomUtil.create('a', 'mapbox-wordmark', map.getContainer())
  wordmark.target = '_blank'
  wordmark.href = 'http://mapbox.com/about/maps'
  wordmark.innerHTML = 'Mapbox'

  return map
}

export function handleLocationData(data, store){
  parseGeoJSON(data, 'point').then(parsedResults => {
    // console.log(parsedResults)
    const mapPoints = parsedResults
    let propertyObj = {}
    store.dispatch('updateState', ['propertyData', data.map(item => propertyObj[item.id] = item)])
    store.dispatch('updateState', ['mapPoints', mapPoints])
    store.dispatch('updateState', ['propertyRscores', mapPoints.reduce(function(retobj, obj) {
      retobj[obj.properties.id] = obj.properties.rscores
      return retobj
    }, {})])
    })
}

export function parseGeoJSON(dataArray, geomtype) {
  return new Promise((resolve, reject) => {
    const jj = dataArray.map(function(item) {
      let gj = ''
      let geom
      if (geomtype == 'point' || (itemIsSecurity(item)) ) {
        geom = item.geometry
      } else {
        geom = item.iso_polygon
      }
      try {
        gj = JSON.parse(geom)
      } catch {
        gj = geom
      }
      return {
        "type": "Feature",
        "properties": {
          "geoname": item.name,
          "geomtype": geomtype,
          "id": item.id,
          "cusip": item.cusip,
          "lvl11_location_id": item.lvl11_location_id,
          "drive_time": item.drive_time,
          "rscores": new risQScores(item.risq_score, item.hurricane_score, item.flood_score, item.wildfire_score, item.wt ),
          "sscores": new SocialScores(item)
        },
        "geometry": gj
      }
    })
    resolve(jj)
  })
}

function itemIsSecurity(item) {
  return Boolean(item.cusip)
}

function featureIsSecurity(feature) {
  return Boolean(feature.properties.cusip)
}

function isochroneUrl(feature) {
  if (featureIsSecurity(feature)) {
    return process.env.VUE_APP_API_HOST + `/properties/${feature.properties.id}/isochrones`
  } else {
    return process.env.VUE_APP_API_HOST + `/custom_location/${feature.properties.lvl11_location_id}/isochrones`
  }

}

export async function getIsochrones(feature) {
  return await axios.get(isochroneUrl(feature), {
    params: {
      cusip: feature.properties.cusip
    }
  })
}
